import React, { Component } from 'react';
import { translate } from '../Services/translation';
import { connect } from 'react-redux';
import { setActiveBahagErrorModal } from '../actions/Bahag.action';

class BahagErrorModal extends Component {

    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
    }

    renderError() {
        return (
            <div className="bahag-error-modal__container">
                <div className="bahag-error-modal__container--close-container">
                    <span onClick={this.handleClose}></span>
                </div>
                <div className="bahag-error-modal__container--inner">
                    <span></span>
                    <h3>{translate("bahag.error.modal.message.title")}</h3>
                    <p>{translate("bahag.error.modal.message.text")}</p>
                    <button onClick={this.handleClose}>{translate("bahag.error.modal.button")}</button>
                </div>
            </div>
        )
    }

    handleClose() {
        this.props.setActiveBahagErrorModal(false);
    }

    render() {
        return (
            <>
                <div className="bahag-error-modal-backdrop" onClick={this.handleClose}></div>
                <div className="bahag-error-modal">
                    {this.renderError()}
                </div>
            </>

        );
    }
}

const mapDispatchToProps = {
    setActiveBahagErrorModal,
};

const mapStateToProps = state => {
    return {
        bahagErrorModal: state.bahag.bahagErrorModal
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BahagErrorModal);